import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "container-fix-padding bg-white" }
const _hoisted_3 = { class: "min-vh-100 p-2" }

import { watch } from 'vue'
import { PageModeType } from '../../types'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'SubPage',
  props: {
    pageMode: { default: 'main_page' },
    onSwitchMode: { type: Function, default: () => {} },
    backLabel: { default: '戻る' }
  },
  setup(__props: any) {

const props = __props

// Watchers
watch(() => props.pageMode, () => {
  window.scroll({ top: 0, behavior: "smooth" })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.pageMode == 'main_page')
      ? _renderSlot(_ctx.$slots, "main_page", { key: 0 })
      : (__props.pageMode == 'sub_page')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "h5 mb-0 p-2 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.onSwitchMode('main_page')))
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1 /* CACHED */)),
                  _createTextVNode(" " + _toDisplayString(__props.backLabel), 1 /* TEXT */)
                ]),
                _createElementVNode("div", null, [
                  _renderSlot(_ctx.$slots, "sub_page")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
  ]))
}
}

})